// extracted by mini-css-extract-plugin
export default {"date-container":"styles_date-container__afdcT","date-label":"styles_date-label__P188w","date-warning":"styles_date-warning__vmoWI"};